import { useEffect } from "react";
import { useSelector } from "react-redux";
function ContentSection() {
  const { data: homeContet } = useSelector(
    (x) => x?.home?.homePageContentResponse
  );

  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  useEffect(() => {
    const links = document.querySelectorAll(".content-section a");
    links.forEach((a) => {
      if (!a.textContent.trim() && !a.getAttribute("aria-label")) {
        const href = a.getAttribute("href") || "";
        a.setAttribute("aria-label", href ? `Link to ${href}` : "External link");
      }
    });
  }, [homeContet]);

  return (
    <>
      <section style={{ backgroundColor: "#ebf5f2" }}
        className="content-section"
        dangerouslySetInnerHTML={{
          __html: homeContet?.contentSectionOneDescription,
        }}
      >
        {/* <div className="row" data-sal="slide-up" data-sal-duration="900">
          <div className="col-lg-6">
            <img
              src={ImageURL + homeContet?.contentSectionOneImage}
              alt="results-based-accountability"
              className="img-fluid"
            />
          </div>
          <div className="col-lg-6">
            <div className="content-box">
              <h2 className="main-title">
                {homeContet?.contentSectionOneTitle}{" "}
              </h2>

              <div className="text-container">
                <div className="text-preview">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: homeContet?.contentSectionOneDescription,
                    }}
                  ></p>
                </div>
                <div className="text-full extra-text">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Cras rhoncus facilisis erat id pulvinar. In imperdiet
                    vestibulum viverra. In nec mollis sem. Phasellus et tellus
                    vitae urna fringilla iaculis. Lorem ipsum dolor sit amet,
                    consectetur adipiscing elit. Cras rhoncus facilisis erat id
                    pulvinar. In imperdiet vestibulum viverra.
                  </p>
                </div>
                <button
                  className="toggle-button read-more-button"
                  onclick="toggleText()"
                >
                  Read More{" "}
                  <i className="csc-arrow-icon bi bi-chevron-down ms-3 me-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div> */}
      </section>

      <section
        className="content-section p-0"
        dangerouslySetInnerHTML={{
          __html: homeContet?.contentSectionTwoDescription,
        }}
      >
        {/* <div className="row" data-sal="slide-left" data-sal-duration="900">
          <div className="col-lg-6">
            <div className="content-box">
              <h2 className="main-title">
                {homeContet?.contentSectionTwoTitle}
              </h2>
              <div className="text-container">
                <div className="text-preview">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: homeContet?.contentSectionTwoDescription,
                    }}
                  ></p>
                </div>
                <div className="text-full extra-text">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Cras rhoncus facilisis erat id pulvinar. In imperdiet
                    vestibulum viverra. In nec mollis sem. Phasellus et tellus
                    vitae urna fringilla iaculis. Lorem ipsum dolor sit amet,
                    consectetur adipiscing elit. Cras rhoncus facilisis erat id
                    pulvinar. In imperdiet vestibulum viverra.
                  </p>
                </div>
                <button
                  className="toggle-button read-more-button"
                  onclick="toggleText()"
                >
                  Read More{" "}
                  <i className="csc-arrow-icon bi bi-chevron-down ms-3 me-1"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              src={ImageURL + homeContet?.contentSectionTwoImage}
              alt="Results-based accountability"
              className="img-fluid"
            />
          </div>
        </div> */}
      </section>

      <section
        className="content-section p-0"
        dangerouslySetInnerHTML={{
          __html: homeContet?.contentSectionThreeDescription,
        }}
      >
        {/* <div className="row" data-sal="slide-down" data-sal-duration="900">
          <div className="col-lg-6">
            <img
              src={ImageURL + homeContet?.contentSectionThreeImage}
              alt="results-based-accountability"
              className="img-fluid"
            />
          </div>
          <div className="col-lg-6">
            <div className="content-box">
              <h2 className="main-title">
                {homeContet?.contentSectionThreeTitle}
              </h2>

              <div className="text-container">
                <div className="text-preview">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: homeContet?.contentSectionThreeDescription,
                    }}
                  ></p>
                </div>
                <div className="text-full extra-text">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Cras rhoncus facilisis erat id pulvinar. In imperdiet
                    vestibulum viverra. In nec mollis sem. Phasellus et tellus
                    vitae urna fringilla iaculis. Lorem ipsum dolor sit amet,
                    consectetur adipiscing elit. Cras rhoncus facilisis erat id
                    pulvinar. In imperdiet vestibulum viverra.
                  </p>
                </div>
                <button
                  className="toggle-button read-more-button"
                  onclick="toggleText()"
                >
                  Read More{" "}
                  <i className="csc-arrow-icon bi bi-chevron-down ms-3 me-1"></i>
                </button>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
}

export default ContentSection;
